import axios from 'axios';
import Auth from '../services/auth';
import { API_ROOT } from './apiConfig';

export default class UserAdministrationDataAccess {

    getUserList(aaUserId) {

        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let userId = "";

            if (aaUserId != null) {
                userId = aaUserId
            }

            let reqBody = {
                account: "zuludatabase", command: "SP_EOM_UserAdmin_GetUserList", parameters: { aaUserId: userId }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    const users = response.data.map((user, i) => {
                        const result = Object.assign({}, user,
                            {
                                Email: user.Email,
                                FirstName: user.FirstName,
                                LastName: user.LastName,
                                IsAdminUser: user.IsAdminUser,
                                IsWizardAccess: user.IsWizardAccess,
                                AAUserId: user.AAUserId

                            });
                        return result;
                    });

                    resolve(users);


                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    getClientMapping(aaUserId) {

        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_EOM_GetMappedUser", parameters: { userId: aaUserId }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    const mapping = response.data.map((userMap, i) => {
                        const result = Object.assign({}, userMap,
                            {
                                Client: userMap.Client,
                                Manager: userMap.Manager
                            });

                        return result;
                    });

                    resolve(mapping);


                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    processUserAdmin(payload) {

        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase",
                command: "SP_EOM_ProcessUserAdministrator",
                parameters: {
                    aaUserId: payload.AAUserId,
                    firstName: payload.FirstName,
                    lastName: payload.LastName,
                    isAdmin: payload.IsAdminUser,
                    isWizard: payload.IsWizardAccess,
                    email: payload.Email,
                    operationType: payload.OperationType,
                    currentUser: auth.getUserEmail()
                }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }
}